/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ServiceRespVo
 */
export interface ServiceRespVo {
    /**
     * 附加服务ID
     * @type {number}
     * @memberof ServiceRespVo
     */
    id?: number;
    /**
     * 附加服务韩文名称
     * @type {string}
     * @memberof ServiceRespVo
     */
    name?: string;
    /**
     * 附加服务中文名称
     * @type {string}
     * @memberof ServiceRespVo
     */
    nameCn?: string;
    /**
     * 附加服务价格
     * @type {number}
     * @memberof ServiceRespVo
     */
    price?: number;
    /**
     * 币种
     * @type {string}
     * @memberof ServiceRespVo
     */
    currencyCode?: string;
}

/**
 * Check if a given object implements the ServiceRespVo interface.
 */
export function instanceOfServiceRespVo(value: object): value is ServiceRespVo {
    return true;
}

export function ServiceRespVoFromJSON(json: any): ServiceRespVo {
    return ServiceRespVoFromJSONTyped(json, false);
}

export function ServiceRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ServiceRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'nameCn': json['nameCn'] == null ? undefined : json['nameCn'],
        'price': json['price'] == null ? undefined : json['price'],
        'currencyCode': json['currencyCode'] == null ? undefined : json['currencyCode'],
    };
}

export function ServiceRespVoToJSON(json: any): ServiceRespVo {
    return ServiceRespVoToJSONTyped(json, false);
}

export function ServiceRespVoToJSONTyped(value?: ServiceRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'nameCn': value['nameCn'],
        'price': value['price'],
        'currencyCode': value['currencyCode'],
    };
}

